module.exports = "<div class=\"spinner\">\r\n    <div class=\"sk-rotating-plane\"></div>\r\n</div>"